import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { ApiProvider } from './api/context';
import { App } from './App';
import { ToastProvider } from './components/Toasts';
import { I18nProvider } from './i18n';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing');

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <ApiProvider>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </ApiProvider>
    </I18nProvider>
  </StrictMode>,
);
